import { Injectable } from '@angular/core';

@Injectable()
export class AdPageHeaderConfig {
  /**
   * é¦é¡µææ¬ï¼è¥æå®ç©ºè¡¨ç¤ºä¸æ¾ç¤º
   */
  home?: string = 'é¦é¡µ';
  /**
   * é¦é¡µé¾æ¥
   */
  home_link?: string = '/';
  /**
   * é¦é¡µé¾æ¥å½éååæ°
   */
  home_i18n?: string;
  /**
   * èªå¨çæå¯¼èªï¼ä»¥å½åè·¯ç±ä»ä¸»èåä¸­å®ä½
   */
  autoBreadcrumb?: boolean = true;
  /**
   * èªå¨çææ é¢ï¼ä»¥å½åè·¯ç±ä»ä¸»èåä¸­å®ä½
   */
  autoTitle?: boolean = true;
  /**
   * æ¯å¦èªå¨å°æ åä¿¡æ¯åæ­¥è³ `TitleService`ã`ReuseService` ä¸
   */
  titleSync?: boolean = false;
}
